/* TS Sliping per post: bildestripe. Miniatyrer (desktop) og teller (mobil) følger sveipet. */
(function () {
  var m = document.querySelector('[data-ts-media]');
  if (!m) return;
  var strip = m.querySelector('[data-ts-strip]');
  var thumbs = m.querySelectorAll('[data-ts-thumb]');
  var count = m.querySelector('[data-ts-count]');
  if (!strip || (!thumbs.length && !count)) return;
  var n = strip.children.length, cur = 0, tick = 0;

  function vis(i) {
    if (i === cur) return;
    cur = i;
    Array.prototype.forEach.call(thumbs, function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    if (count) count.textContent = (i + 1) + ' / ' + n;
  }
  strip.addEventListener('scroll', function () {
    if (tick) return;
    tick = requestAnimationFrame(function () {
      tick = 0;
      var w = strip.clientWidth || 1;
      vis(Math.max(0, Math.min(n - 1, Math.round(strip.scrollLeft / w))));
    });
  }, { passive: true });
  Array.prototype.forEach.call(thumbs, function (t, i) {
    t.addEventListener('click', function () {
      var rolig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      strip.scrollTo({ left: i * strip.clientWidth, behavior: rolig ? 'auto' : 'smooth' });
      vis(i);
    });
  });
})();
